module.exports = __webpack_public_path__ + "static/sample-projects-12-4a57bc2f33e932b9fe542a7aba990518.png";